
    import "src/shared/components/InventoryInfoSlider/components/index.module.scss?farm_css_modules";
    
    export default {"filterDiv": `filterDiv-0093a3b5`,"filterParentDiv": `filterParentDiv-0093a3b5`,"iconWrap": `iconWrap-0093a3b5`,"timelineText": `timelineText-0093a3b5`}
    